export const POS_CUSTOMER_COPY_KOT_NUMBER_KEY =
  "pos_add_kot_number_to_customer_copy";

export const extractKotNumberFromResponse = (response = {}) => {
  const value =
    response?.kot_number ??
    response?.kotNumber ??
    response?.kotid ??
    response?.data?.kot_number ??
    response?.data?.kotNumber ??
    response?.data?.kotid;
  const normalized = String(value ?? "").trim();
  return normalized || null;
};

export const resolveCustomerCopyKotNumber = (receipt = {}, enabled = false) => {
  if (!enabled) return null;

  const value =
    receipt?.tokenNo ??
    receipt?.kot_number ??
    receipt?.kotNumber ??
    receipt?.kotid ??
    receipt?.kot_no ??
    receipt?.display_kot_number;
  const normalized = String(value ?? "").trim();
  return normalized || null;
};

/**
 * Builds one item-wise KOT slip per product line. Repeated entries for the
 * same cart line are combined so the complete product quantity stays on one
 * slip instead of printing one slip per unit.
 */
export const buildSeparateKotItemGroups = (items = []) => {
  const groupsByProduct = new Map();

  (Array.isArray(items) ? items : []).forEach((item, index) => {
    const rawQty = Number(item?.qty ?? item?.quantity ?? 0);
    if (!Number.isFinite(rawQty) || rawQty <= 0) return;

    const productKey = String(
      item?.lineKey ??
        item?.key ??
        [
          item?.productid ?? item?.product_id ?? item?.id ?? item?.name ?? "item",
          item?.variantid ?? item?.variant_id ?? "base",
          Array.isArray(item?.addon_ids) ? item.addon_ids.join(",") : "",
        ].join(":")
    );
    const safeKey = productKey || `item:${index}`;
    const existing = groupsByProduct.get(safeKey);

    if (existing) {
      const combinedQty = Number(existing.qty) + rawQty;
      groupsByProduct.set(safeKey, {
        ...existing,
        qty: combinedQty,
        quantity: combinedQty,
      });
      return;
    }

    groupsByProduct.set(safeKey, {
      ...item,
      qty: rawQty,
      quantity: rawQty,
    });
  });

  return Array.from(groupsByProduct.values(), (item) => [item]);
};
